import React from "react";
import { Link } from "react-router-dom";
import i18n from "../../../i18n";
import {
  Car,
  FileText,
  FilePlus,
  Image,
  Info,
  Phone,
  ScrollText,
} from "lucide-react";

export class AuctionTabs extends React.Component {
  constructor() {
    super();
    let path = window.location.pathname;
    let auctionId = path.substring(path.lastIndexOf("/") + 1, path.length);
    this.state = {
      auctionId: auctionId,
    };
  }

  render() {
    let id = this.state.auctionId;
    let activeTab = this.props.activeTab;

    const tabs = [
      {
        key: "details",
        icon: <Info size={16} />,
        label: i18n.t("details"),
        to: `/auction/edit/${id}`,
      },
      {
        key: "uploader",
        icon: <Image size={16} />,
        label: i18n.t("media_files"),
        to: `/auction/image/${id}`,
      },
      {
        key: "enquiry",
        icon: <Phone size={16} />,
        label: i18n.t("enquiry"),
        to: `/auction/enquiries/${id}`,
      },
      {
        key: "contracts",
        icon: <FileText size={16} />,
        label: i18n.t("documents"),
        to: `/auction/contracts/${id}`,
      },
      {
        key: "terms",
        icon: <ScrollText size={16} />,
        label: i18n.t("terms_conditions"),
        to: `/auction/terms/${id}`,
      },
      {
        key: "additional",
        icon: <FilePlus size={16} />,
        label: i18n.t("additional_info"),
        to: `/auction/additional/${id}`,
      },
      {
        key: "vehicle",
        icon: <Car size={16} />,
        label: i18n.t("vehicle_info"),
        to: `/auction/vehicle/${id}`,
      },
    ];

    return (
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "4px",
          marginBottom: "24px",
          borderBottom: "1px solid #e5e7eb",
          paddingBottom: "0",
        }}
      >
        {tabs.map((tab) => {
          const isActive = activeTab === tab.key;
          return (
            <Link
              key={tab.key}
              to={tab.to}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "6px",
                padding: "10px 16px",
                fontSize: "0.85rem",
                fontWeight: isActive ? "600" : "400",
                color: isActive ? "#2a3a5a" : "#6b7280",
                textDecoration: "none",
                borderBottom: isActive ? "2px solid #2a3a5a" : "2px solid transparent",
                marginBottom: "-1px",
                transition: "all 0.2s ease",
                whiteSpace: "nowrap",
              }}
            >
              {tab.icon}
              {tab.label}
            </Link>
          );
        })}
      </div>
    );
  }
}